import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { wordpressLogin } from "../services/API";
import { useAuth } from "../contexts/AuthContext";
import { Flex, Spinner, Text, VStack, Heading } from '@chakra-ui/react';

const WordPressSSOHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const [status, setStatus] = useState('loading');
  const [processingComplete, setProcessingComplete] = useState(false);

  useEffect(() => {
    if (processingComplete) return;

    const handleWordpressSSO = async () => {
      try {
        const token = new URLSearchParams(location.search).get("token");

        if (!token) {
          console.log("No token found in URL");
          setStatus('error');
          setTimeout(() => navigate("/login"), 2000);
          return;
        }

        console.log("Processing WordPress SSO with token");
        setProcessingComplete(true);
        
        const response = await wordpressLogin(token);
        
        if (response.success) {
          console.log("WordPress SSO successful");
          setStatus('success');
          
          if (response.data) {
            await setUser(response.data);
          }
          
          setTimeout(() => navigate("/chat"), 1500);
        } else {
          console.log("WordPress SSO failed:", response.error);
          setStatus('error');
          setTimeout(() => navigate("/login"), 2000);
        }
      } catch (error) {
        console.error("Error in WordPress SSO:", error);
        setStatus('error');
        setProcessingComplete(true);
        setTimeout(() => navigate("/login"), 2000);
      }
    };

    handleWordpressSSO();
    
    return () => {
      console.log("WordPress SSO component unmounting");
    };
  }, [location, navigate, setUser, processingComplete]);

  return (
    <Flex 
      direction="column" 
      align="center" 
      justify="center" 
      minH="100vh"
      bg="#ffffff"
      color="#1f2937"
    >
      <VStack spacing={6} p={8} bg="#f8fafc" borderRadius="md" boxShadow="md">
        <Heading size="lg">ASC</Heading>
        
        {status === 'loading' && (
          <>
            <Spinner size="xl" color="blue.500" thickness="4px" />
            <Text>Completing your login from WordPress...</Text>
          </>
        )}
        
        {status === 'success' && (
          <>
            <Text color="green.400" fontSize="lg">✓ Login successful!</Text>
            <Text>Redirecting to ASC...</Text>
          </>
        )}
        
        {status === 'error' && (
          <>
            <Text color="red.400">Authentication failed.</Text>
            <Text>Redirecting to login page...</Text>
          </>
        )}
      </VStack>
    </Flex>
  );
};

export default WordPressSSOHandler;
